// src/Components/Promo/PortfolioEmailSettings.js

import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

const ORANGE_COLOR = '#FF9900';
const DARK_BLUE = '#00008B';
const LIGHT_BLUE_BG = '#E3F2FD';

export default function PortfolioEmailSettings({ selectedItem, actions }) {
  const isDisabled = !selectedItem;
  const FIELD_WIDTH = '550px';
  const STACK_SPACING = 1.5;

  const orangeBorderSx = {
    '& .MuiOutlinedInput-root': {
      '& fieldset': { borderColor: ORANGE_COLOR },
      '&:hover fieldset': { borderColor: ORANGE_COLOR, borderWidth: '2px' },
      '&.Mui-focused fieldset': { borderColor: ORANGE_COLOR, borderWidth: '2px' },
    },
  };

  const commonInputSx = {
    width: '100%',
    ...orangeBorderSx,
    '& .MuiInputBase-root': {
      fontSize: '0.8rem',
      backgroundColor: LIGHT_BLUE_BG,
      color: DARK_BLUE,
    },
    '& .MuiInputBase-input': {
      padding: '6px 8px',
      color: DARK_BLUE,
      fontWeight: 'normal',
      textTransform: 'none !important',
    },
    '& .MuiInputLabel-root': { top: '-5px' },
  };

  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        width: '100%',
        height: '100%',
        bgcolor: '#fff',
        overflowY: 'auto',
      }}>
      <Typography variant='h6' fontWeight='bold' sx={{ mt: 0, mb: 2, fontSize: '1rem' }}>
        Email Settings
      </Typography>

      <Stack spacing={STACK_SPACING} sx={{ maxWidth: FIELD_WIDTH }}>
        <Box>
          <Typography variant='caption' sx={{ color: '#000000', fontWeight: 'bold' }}>
            Email Salutation
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={2}
            variant='outlined'
            size='small'
            sx={commonInputSx}
            placeholder='Enter email salutation...'
            disabled={isDisabled}
            value={selectedItem?.salutation || ''}
            onChange={(e) =>
              actions.handleFieldChange(selectedItem.id, 'salutation', e.target.value)
            }
          />
        </Box>

        <Box>
          <Typography variant='caption' sx={{ color: '#000000', fontWeight: 'bold' }}>
            Email Close
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={2}
            variant='outlined'
            size='small'
            sx={commonInputSx}
            placeholder='Enter email close...'
            disabled={isDisabled}
            value={selectedItem?.emailClose || ''}
            onChange={(e) =>
              actions.handleFieldChange(selectedItem.id, 'emailClose', e.target.value)
            }
          />
        </Box>
      </Stack>
    </Box>
  );
}
